module.exports = __webpack_public_path__ + "static/change-18ec2f28eebef173c4425f5d12180268.png";